module.exports = "pegasus/assets/custom-2-twitter.png";